module.exports = __webpack_public_path__ + "static/media/salat.becd5783.svg";